import CreditCardIcon from '@mui/icons-material/CreditCard';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';

export type PaymentMethodTabValue = 'card' | 'pix';

interface PaymentMethodTabsProps {
  value: PaymentMethodTabValue;
  onChange: (value: PaymentMethodTabValue) => void;
  showPix?: boolean;
}

const PaymentMethodTabs = ({
  value,
  onChange,
  showPix = false,
}: PaymentMethodTabsProps) => (
  <Box
    sx={{
      mb: 3,
      mx: { xs: 1, sm: 2 },
      bgcolor: '#fff',
      borderRadius: 2,
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Tabs
      value={value}
      onChange={(_, newValue: PaymentMethodTabValue) => onChange(newValue)}
      variant="fullWidth"
      sx={{
        minHeight: 56,
        '& .MuiTab-root': {
          fontWeight: 'bold',
          fontSize: '0.95rem',
          minHeight: 56,
          textTransform: 'none',
        },
        '& .Mui-selected': {
          color: 'primary.main',
        },
        '& .MuiTabs-indicator': {
          height: 3,
          borderRadius: '3px 3px 0 0',
        },
      }}
    >
      <Tab
        icon={<CreditCardIcon />}
        iconPosition="start"
        label="Cartão"
        value="card"
      />
      {showPix && (
        <Tab
          icon={<QrCode2Icon />}
          iconPosition="start"
          label="PIX"
          value="pix"
        />
      )}
    </Tabs>
  </Box>
);

export default PaymentMethodTabs;
